import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=23cf0e4c&scoped=true&"
import script from "./BaseForm.vue?vue&type=script&lang=ts&"
export * from "./BaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./BaseForm.vue?vue&type=style&index=0&id=23cf0e4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf0e4c",
  null
  
)

export default component.exports